import { render, staticRenderFns } from "./PopoverOption.vue?vue&type=template&id=3165428c&"
import script from "./PopoverOption.vue?vue&type=script&lang=js&"
export * from "./PopoverOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports